module.exports = __webpack_public_path__ + "static/media/{S} HARPER logo cut.809b2c27.jpg";